export const GRAPH_COLOR_MAIN = '#3DCD58';
export const GRAPH_COLOR_EXTRA = [
  '#1A79A9',
  '#DD8235',
  '#71CBE0',
  '#007325',
  '#C86E7F',
  '#80C98B',
  '#9286A6',
  '#F2C82B',
  '#46226A',
];

export const LABEL_COLOR = '#333333';
export const TICK_COLOR = '#626469';
